import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=cdb5ed4e&scoped=true"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"
import style0 from "./AddToCart.vue?vue&type=style&index=0&id=cdb5ed4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb5ed4e",
  null
  
)

export default component.exports